import api from './api';

export interface AccountDeletionStatus {
  status: 'NONE' | 'REQUESTED' | 'COMPLETED';
  referenceNumber: string | null;
  requestedAt: string | null;
  completedAt: string | null;
}

export interface AccountDeletionResponse {
  status?: string;
  referenceNumber: string;
  message: string;
}

export interface PushDevicePayload {
  deviceId: string;
  platform: 'android' | 'ios' | 'web';
  pushToken: string;
  appVersion?: string;
  locale?: string;
  enabled?: boolean;
}

export const accountService = {
  getAccountDeletionStatus: async (): Promise<AccountDeletionStatus> => {
    const response = await api.get<AccountDeletionStatus>('/users/me/account-deletion');
    return response.data;
  },

  requestAccountDeletion: async (payload: {
    confirmation: string;
    reason?: string;
  }): Promise<AccountDeletionResponse> => {
    const response = await api.post<AccountDeletionResponse>('/users/me/account-deletion', payload);
    return response.data;
  },

  requestPublicAccountDeletion: async (payload: {
    identifier: string;
    contact?: string;
    reason?: string;
  }): Promise<AccountDeletionResponse> => {
    const response = await api.post<AccountDeletionResponse>('/users/account-deletion/request', payload);
    return response.data;
  },

  registerPushDevice: async (payload: PushDevicePayload) => {
    const response = await api.post('/users/me/devices', payload);
    return response.data;
  },

  disablePushDevice: async (payload: { deviceId?: string; pushToken?: string }) => {
    const response = await api.post('/users/me/devices/disable', payload);
    return response.data;
  },
};

export default accountService;
